<template>
  <div class="box-shadow" v-if="can_access('counterparty','modify')">
  <form @submit.stop.prevent ref="form" class="col-md-12">
    <div class="row">
    <div class="form-group col-sm-8">
        <label class="active">Counterparty Name</label>
        <vue-bootstrap-typeahead
            ref="counterparty_name"
            :data="counterparty"
            v-model="formInput.name"
            :serializer="counterpartyFormattedDisplay"
            placeholder="Type Counterparty Name"
            @hit="setCounterpartyInfo"
            :minMatchingChars="0"
        />
    </div>
    <div class="form-group col-sm-4">
        <label>Broker Code</label>
        <input type="text" placeholder="" class="form-control" v-model="formInput.broker_code">
    </div>
    <div class="form-group col-sm-4">
        <label>Status</label>
        <select name="type" class="form-control" v-model="formInput.status">
            <option selected value="1">Active</option>
            <option value="0">Inactive</option>
        </select>
    </div>
    </div>
    <div class="mt-4" style="display:flow-root">
	    <button class="btn btn-lg btn-info pull-right" @click="set_counterparty" :disabled="btn_disabled">Submit</button>
    </div>
  </form>
  </div>
</template>
<script>
import $ from 'jquery';
import common from '@/assets/js/common.js';
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import { mapActions } from 'vuex';
export default {
  name: "AddRemoveCounterparty",
  mixins: [common],
  components: {
      VueBootstrapTypeahead
  },
  props: {},
  data(){
    return {
      counterparty: [],
      btn_disabled: false,
      formInput: {
          name: '',
          broker_code: '',
          status: 1,
      }
    }
  },
  created(){
    this.call_axios('get_counterparty?with_disabled=1').then(res => {
        console.log(res)
        this.counterparty = res.response.data;
    });
  },
  methods:{
    ...mapActions('layout', ['changeBodyLoading']),
    counterpartyFormattedDisplay(result){
        return result.name;
    },
    setCounterpartyInfo (group) {
      this.formInput.name = (typeof group == "object") ? group.name : group;
      this.formInput.broker_code = (typeof group == "object") ? group.broker_code : group;
      this.formInput.status = (typeof group == "object") ? group.status : group;
    },
    set_counterparty(){
        this.call_axios('set_counterparty','post',this.formInput).then(res => {
            this.$emit('forceRerender', res.response);
        })
    }
  }
}
</script>